import PropTypes from 'prop-types';
import React from 'react';

import LastUpdated from '../../components/lib/LastUpdated/LastUpdated';
import TimeListened from '../../components/lib/TimeListened/TimeListened';
import { SORT_BY } from '../../constants/MyStations';

class StationRowItemRightColChild extends React.Component {
  static propTypes = {
    stationCreated: PropTypes.string,
    shouldHideDate: PropTypes.bool,
    sortBy: PropTypes.string,
    totalPlayTime: PropTypes.number,
  };

  render() {
    let rightColChild = null;
    if (this.props.stationCreated) {
      const dateCollected = new Date(this.props.stationCreated);
      rightColChild = this.props.shouldHideDate ? null : (
        <LastUpdated now={new Date()} dateCollected={dateCollected} />
      );
    }
    if (this.props.sortBy === SORT_BY.playTime) {
      rightColChild = <TimeListened secondsListened={this.props.totalPlayTime} />;
    }
    return rightColChild;
  }
}

export default StationRowItemRightColChild;
